import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'pn-link-list',
  styleUrl: 'pn-link-list.scss',
})
export class PnLinkList {
  @Prop() heading: string = null;
  @Prop() label: string = null;
  @Prop() preamble: string = null;
  @Prop() url: string = null;
  @Prop() showMoreLabel: string = null;
  @Prop() showMoreUrl: string = null;

  private slider: HTMLElement = null;
  private isDragging = false;
  private startX = 0;
  private scrollLeft = 0;

  componentDidLoad() {
    this.slider = document.querySelector('.link-list__container') as HTMLElement;
  }

  private handleMouseDown = (e: MouseEvent) => {
    const target = e.target as HTMLElement;

    const isContainerClick = target.classList.contains('link-list__container');
    const isLinkClick = target.tagName === 'A';

    if (isContainerClick || isLinkClick) {
      this.isDragging = true;
      this.slider?.classList.add('link-list__active');
      this.startX = e.pageX - this.slider?.offsetLeft;
      this.scrollLeft = this.slider?.scrollLeft;

      if (isLinkClick) {
        e.preventDefault();
      }
    }
  };

  private handleMouseLeave = () => {
    this.isDragging = false;
    this.slider?.classList.remove('link-list__active');
  };

  private handleMouseUp = () => {
    this.isDragging = false;
    this.slider?.classList.remove('link-list__active');
  };

  private handleMouseMove = (e: MouseEvent) => {
    if (this.isDragging) {
      const x = e.pageX - this.slider?.offsetLeft;
      const move = (x - this.startX) * 2;
      this.slider.scrollLeft = this.scrollLeft - move;
    }
  };

  render() {
    return (
      <Host>
        {(this.heading || this.preamble) && (
          <div class="link-list__header">
            {this.heading && <h2 class="link-list__heading">{this.heading}</h2>}
            {this.preamble && <p class="link-list__preamble">{this.preamble}</p>}
          </div>
        )}
        <div class="link-list">
          <div
            class="link-list__container"
            onMouseDown={this.handleMouseDown}
            onMouseUp={this.handleMouseUp}
            onMouseLeave={this.handleMouseLeave}
            onMouseMove={this.handleMouseMove}
          >
            <div class="link-list__scrollable">
              <slot name="linklist" />
            </div>
          </div>
        </div>
        {this.showMoreUrl ? (
          <div class="link-list__button">
            <pn-button appearance="light" href={this.showMoreUrl}>
              {this.showMoreLabel}
            </pn-button>{' '}
          </div>
        ) : (
          ''
        )}
      </Host>
    );
  }
}
